import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import usePageSEO from "@/hooks/usePageSEO";

const NotFound = () => {
  const location = useLocation();

  usePageSEO({
    title: "404 Page Not Found | 1 Wood Floors",
    description: "This page does not exist but your perfect hardwood floor does. Visit 1 Wood Floors to explore Michigan hardwood flooring, installation and refinishing.",
    path: location.pathname,
    noindex: true,
  });

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
